import React from 'react';
import ItemCarousel from '../ItemCarousel';
import OfferCard from '../Articles/Offers/OfferCard';
import {SkeletonLoader} from '../SkeletonLoader';
import {useOffers} from '../../hooks/useOffers';
import {Offer} from '../../types/article';
import { TextG14, TextG20 } from '../typography';

interface IndividualRedemptionsCarouselProps {
  communityId?: string;
}

/**
 * Home-screen widget that surfaces the authenticated user's available
 * individual redemptions. Hidden entirely when the user has none.
 *
 * The "Insiders Only" community label is suppressed via `showExclusive={false}`
 * because individual redemptions are not curated by community exclusivity.
 */
const IndividualRedemptionsCarousel: React.FC<IndividualRedemptionsCarouselProps> = ({
  communityId,
}) => {
  const {offers, offersIsLoading} = useOffers({
    communityId,
    onlyIndividualRedemptions: true,
  });

  if (offersIsLoading) {
    return <SkeletonLoader mt="34px" cardBorderRadius="12px" />;
  }

  if (!offers || offers.length === 0) {
    return null;
  }

  return (
    <ItemCarousel
      mb="12px"
      TitleComponent={TextG20}
      SubtitleComponent={TextG14}
      title="Local Perks Just For You"
      titleUpperCase={false}
      subtitle="Enjoy this great reason to explore your community!"
      swiperProps={{
        autoHeight: true,
        slidesPerGroup: 1,
        slidesPerView: 1,
        items: offers,
        render: (item) => <OfferCard offer={item as Offer} showExclusive={false} />,
      }}
    />
  );
};

export default IndividualRedemptionsCarousel;
